export const selectFactoryOfficesByCity = (state) => state.factoryOffices.officesByCity.elements;
export const selectFactoryOfficesByCityLoading = (state) => state.factoryOffices.officesByCity.loading;
export const selectFactoryOfficesByCityError = (state) => state.factoryOffices.officesByCity.error;

export const selectFactoryOfficesByProvince = (state) => state.factoryOffices.officesByProvince.elements;
export const selectFactoryOfficesByProvinceLoading = (state) => state.factoryOffices.officesByProvince.loading;
export const selectFactoryOfficesByProvinceError = (state) => state.factoryOffices.officesByProvince.error;